import "core-js/modules/es.array.concat.js";
import algoliasearch from 'algoliasearch/lite.js';
import { useLocalization } from '~/composables/_next/useLocalization';
var cachedClient = null;

/**
 * Returns a shared Algolia search client instance
 * @returns {{ searchClient: ReturnType<typeof algoliasearch> }}
 */
export function useAlgoliaSearch() {
  var _process$env$ALGOLIA_, _process$env$ALGOLIA_2, _process$env$CURRENT_, _process$env$CURRENT_2;
  var _useNuxt2App = useNuxt2App(),
    i18n = _useNuxt2App.i18n;
  var _useLocalization = useLocalization(),
    locale = _useLocalization.locale;
  var appId = (_process$env$ALGOLIA_ = process.env.ALGOLIA_APP_ID) !== null && _process$env$ALGOLIA_ !== void 0 ? _process$env$ALGOLIA_ : '';
  var apiKey = (_process$env$ALGOLIA_2 = process.env.ALGOLIA_APP_KEY) !== null && _process$env$ALGOLIA_2 !== void 0 ? _process$env$ALGOLIA_2 : '';
  if (!cachedClient) {
    cachedClient = algoliasearch(appId, apiKey);
  }
  var lang = locale.toUpperCase();
  var env = (_process$env$CURRENT_ = (_process$env$CURRENT_2 = process.env.CURRENT_ENV) === null || _process$env$CURRENT_2 === void 0 ? void 0 : _process$env$CURRENT_2.toUpperCase()) !== null && _process$env$CURRENT_ !== void 0 ? _process$env$CURRENT_ : 'DEV';
  var indexAdvice = "".concat(lang, "_contentful_Advice_").concat(env);
  var indexRecipe = "".concat(lang, "_contentful_Recipe_").concat(env);
  var indexProduct = "".concat(lang, "_commercetools_").concat(env);
  var filtersRecipes = [{
    attribute: 'recipeIngredients',
    title: i18n.t('search.filters.recipeIngredients')
  }, {
    attribute: 'recipeBeneficialProperties',
    title: i18n.t('filters.proprietesFilter')
  }, {
    attribute: 'recipeSpecificProblems',
    title: i18n.t('filters.problematiques-filter')
  }, {
    attribute: 'recipeAdaptedFor',
    title: i18n.t('filters.adapte-pour')
  }, {
    attribute: 'recipeCosmeticFamilies',
    title: i18n.t('filters.categories')
  }, {
    attribute: 'recipeHairTypes',
    title: i18n.t('search.filters.type-de-cheveux')
  }, {
    attribute: 'recipeSkinTypes',
    title: i18n.t('search.filters.recipeSkinTypes')
  }, {
    attribute: 'recipeDifficulty',
    title: i18n.t('search.filters.recipeDifficulty')
  }, {
    attribute: 'recipePreparationTime',
    title: i18n.t('search.filters.recipePreparationTime')
  }];
  var sortsRecipes = computed(function () {
    var lang = locale.toUpperCase();
    var env = process.env.CURRENT_ENV.toUpperCase();
    var base = "".concat(lang, "_contentful_Recipe_").concat(env);
    return [{
      value: "".concat(base),
      label: i18n.t('sort.relevancy'),
      id: "".concat(base)
    }, {
      value: "".concat(base, "_createdAt_desc"),
      label: i18n.t('sort.latest'),
      id: "".concat(base, "_createdAt_desc")
    }, {
      value: "".concat(base, "_createdAt_asc"),
      label: i18n.t('sort.oldest'),
      id: "".concat(base, "_createdAt_asc")
    }, {
      value: "".concat(base, "_name_asc"),
      label: i18n.t('sort.nameAsc'),
      id: "".concat(base, "_name_asc")
    }, {
      value: "".concat(base, "_name_desc"),
      label: i18n.t('sort.nameDesc'),
      id: "".concat(base, "_name_desc")
    }];
  });
  var filtersProducts = [{
    attribute: 'attributes.adapte-pour',
    title: i18n.t('filters.adapte-pour')
  }, {
    attribute: 'attributes.culture',
    title: i18n.t('filters.culture')
  }, {
    attribute: 'attributes.problematiques-beaute',
    title: i18n.t('filters.problematiquesFilter')
  }, {
    attribute: 'attributes.propietes-beaute',
    title: i18n.t('filters.proprietes-beaute')
  }, {
    attribute: 'attributes.type-de-cheveux',
    title: i18n.t('filters.typeDeCheveux')
  }, {
    attribute: 'attributes.type-de-peaux',
    title: i18n.t('filters.typeDePeaux')
  }, {
    attribute: 'attributes.univers-olfactif',
    title: i18n.t('filters.universOlfactif')
  }, {
    attribute: 'variants.prices.EUR.max',
    title: i18n.t('filters.price.title')
  }];
  var sortsProducts = computed(function () {
    var lang = locale.toUpperCase();
    var env = process.env.CURRENT_ENV.toUpperCase();
    var base = "".concat(lang, "_commercetools_").concat(env);
    return [{
      value: "".concat(base),
      label: i18n.t('sort.relevancy'),
      id: "".concat(base)
    }, {
      value: "".concat(base, "_price_asc"),
      label: i18n.t('sort.priceAsc'),
      id: "".concat(base, "_price_asc")
    }, {
      value: "".concat(base, "_price_desc"),
      label: i18n.t('sort.priceDesc'),
      id: "".concat(base, "_price_desc")
    }, {
      value: "".concat(base, "_name_asc"),
      label: i18n.t('sort.nameAsc'),
      id: "".concat(base, "_name_asc")
    }, {
      value: "".concat(base, "_name_desc"),
      label: i18n.t('sort.nameDesc'),
      id: "".concat(base, "_name_desc")
    }, {
      value: "".concat(base, "_createdAt_desc"),
      label: i18n.t('sort.latest'),
      id: "".concat(base, "_createdAt_desc")
    }, {
      value: "".concat(base, "_createdAt_asc"),
      label: i18n.t('sort.oldest'),
      id: "".concat(base, "_createdAt_asc")
    }, {
      value: "".concat(base, "_best_sellers"),
      label: i18n.t('sort.bestsellers'),
      id: "".concat(base, "_best_sellers")
    }];
  });
  var filtersAdvices = [{
    attribute: 'category',
    title: i18n.t('filters.categories')
  }];
  var sortsAdvices = computed(function () {
    var lang = locale.toUpperCase();
    var env = process.env.CURRENT_ENV.toUpperCase();
    var base = "".concat(lang, "_contentful_Advice_").concat(env);
    return [{
      value: base,
      label: 'Pertinence',
      id: base
    }, {
      value: "".concat(base, "_createdAt_desc"),
      label: 'Plus récent',
      id: "".concat(base, "_createdAt_desc")
    }, {
      value: "".concat(base, "_createdAt_asc"),
      label: 'Plus ancien',
      id: "".concat(base, "_createdAt_asc")
    }, {
      value: "".concat(base, "_name_asc"),
      label: 'Nom A-Z',
      id: "".concat(base, "_name_asc")
    }, {
      value: "".concat(base, "_name_desc"),
      label: 'Nom Z-A',
      id: "".concat(base, "_name_desc")
    }];
  });
  return {
    searchClient: cachedClient,
    indexProduct: indexProduct,
    indexRecipe: indexRecipe,
    indexAdvice: indexAdvice,
    filtersRecipes: filtersRecipes,
    sortsRecipes: sortsRecipes,
    filtersProducts: filtersProducts,
    sortsProducts: sortsProducts,
    filtersAdvices: filtersAdvices,
    sortsAdvices: sortsAdvices
  };
}